<script lang="ts">
  import Text from './Text.svelte';

  export let files: FileList | undefined;
  export let name: string;
  export let accept: string;
  export let label: string = '';
</script>

<div class="upload">
  <label>
    {label}
    <input bind:files type="file" {name} {accept} on:change />
  </label>
  <Text size="medium">{(files && files[0].name) || 'Keine Datei'} wurde hochgeladen</Text>
</div>

<style lang="scss">
  @use '../styles/colors';
  @use '../styles/spacing';
  @use '../styles/font-sizes';

  .upload {
    display: flex;
    flex-wrap: wrap;
    gap: spacing.$s;
    align-items: center;
    margin-top: spacing.$xs;

    label {
      align-self: start;
      padding: spacing.$xxs spacing.$m;
      font-weight: 700;
      font-size: font-sizes.$text-s;
      font-variant-numeric: lining-nums;
      line-height: 2;
      color: colors.$primary;
      border: 2px solid colors.$primary;
      border-radius: 4px;
      cursor: pointer;

      &:hover,
      &:focus {
        color: colors.$primaryDark;
        border-color: colors.$primaryDark;
      }

      &:focus {
        box-shadow: 0 0 0 2px colors.$black30, 0 0 0 5px colors.$black10;
        outline: none;
      }

      input {
        visibility: hidden;
        width: 0;
        height: 0;
      }
    }
  }
</style>
